import React, { useCallback } from "react";
import { slide as Slide } from "react-burger-menu";
import { Paths } from "../../../Paths";
import { CrossIcon } from "../common/icons/CrossIcon";
import { SideMenuContent } from "./SideMenuContent";
import { useNavigate } from "react-router-dom";
import { HeaderLogo } from "../header/HeaderLogo";

export const MobileSideMenu = React.memo(function MobileSideMenu(props: MobileSideMenuProps) {
    const {
        isOpenSlide,
        handleSlideOpen,
        handleSlideClose,
        withSideMenuContent
    } = props;

    const navigate = useNavigate();

    const handleTitleClicked = useCallback(() => {
        navigate(Paths.root);
    }, [history]);

    return (
        <Slide
            burgerButtonClassName={"default_burger_button"}
            crossButtonClassName={"side_menu_close"}
            customCrossIcon={<CrossIcon />}
            overlayClassName={"side_menu_overlay"}
            isOpen={isOpenSlide}
            onOpen={handleSlideOpen}
            onClose={handleSlideClose}
        >
            <div className={"side_menu"}>
                <ul>
                    <li className={"side_menu__row"} onClick={handleTitleClicked}>
                        <HeaderLogo />
                    </li>
                    {withSideMenuContent && <SideMenuContent />}
                </ul>
            </div>
        </Slide>
    );
});

type MobileSideMenuProps = {
    isOpenSlide: boolean,
    handleSlideOpen: () => void,
    handleSlideClose: () => void,
    withSideMenuContent?: boolean
}
